import { useEffect, useState } from "react";
import EventCategoryTable from "./EventCategoryTable";
import EventCategoryForm from "./EventCategoryForm";
import Modal from "components/common/Modal";
import Alert from "components/common/Alert";
import { useEventCategory } from "./hooks/useEventCategory";
import { useOrganizers } from "components/company/hooks/useOrganizers";
import EventCategoryModal from "./EventCategoryModal";

export default function EventCategoryContainer() {
  const {
    data,
    loading,
    loadCategories,
    addCategory,
    editCategory,
    deleteCategory,
  } = useEventCategory();

  const userId = "69579c6190a653b640e65639";

  const [editing, setEditing] = useState(null);
  const [openAdd, setOpenAdd] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  useEffect(() => {
    if (selectedOrganizer) loadCategories(selectedOrganizer);
  }, [selectedOrganizer]);

  useEffect(() => {
  const handleOrganizerChange = (e) => {
    setSelectedOrganizer(e.detail);
  };

  window.addEventListener("companyChanged", handleOrganizerChange);
  return () =>
    window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  return (
    <>
      <div className="mb-4 flex justify-end">
        <button
          className="rounded bg-blue-600 px-4 py-2 text-white"
          onClick={() => setOpenAdd(true)}
        >
          + Add Event Category
        </button>
      </div>

      {/* {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          autoClose
          onClose={() => setAlert({ type: "", message: "" })}
        />
      )} */}

      <EventCategoryTable
        data={data}
        loading={loading}
        onEdit={setEditing}
        onDelete={async (row) => {
          try {
            const res = await deleteCategory(row._id, {
              is_deleted: true,
              deleted_by: userId,
            });

            setAlert({
              type: "success",
              message: res.data?.message,
            });

            loadCategories(selectedOrganizer);
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Unable to delete event category",
            });
          }
        }}
      />

      {/* Add */}
      <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
        <EventCategoryModal
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("created_by", userId);
              await addCategory(payload);
              setOpenAdd(false);
              loadCategories(selectedOrganizer);
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                "Failed to create event category"
              );
            }
          }}
        />
      </Modal>

      {/* Edit */}
      <Modal open={!!editing} onClose={() => setEditing(null)}>
        <EventCategoryModal
          initialData={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("updated_by", userId);

              await editCategory(editing._id, payload);
              setEditing(null);
              loadCategories(selectedOrganizer);
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                "Failed to update event category"
              );
            }
          }}
        />
      </Modal>

    </>
  );
}
